import { useCallback } from 'react';

import useAxios from '@services/api';

import { CreateKeyFormInputs } from './CreateKeyForm/create-key-form.types';
import type { GameKeyRow } from './master.types';

export const useFetchGameKeys = () => {
  const { response, error, issueRequest } = useAxios<GameKeyRow[]>();

  const fetchGameKeys = useCallback(() => {
    console.log('🔄 fetchGameKeys called');
    void issueRequest({ 
      url: `/admin/games/keys`, 
      method: 'get' 
    });
  }, [issueRequest]);

  // Логируем ошибки для отладки
  if (error) {
    console.log('useFetchGameKeys error:', error);
  }

  // Логируем обновления response
  if (response) {
    console.log('📊 useFetchGameKeys response updated:', response.length, 'keys');
  }

  return [response, fetchGameKeys, error] as const;
};

export const useDeleteGameKey = () => {
  const { response, error, issueRequest } = useAxios<Record<string, never>>();
  
  const deleteGameKey = useCallback((id: string) => {
    return issueRequest({ url: `/admin/games/keys/${id}`, method: 'delete' });
  }, [issueRequest]);

  // Логируем ошибки для отладки
  if (error) {
    console.log('useDeleteGameKey error:', error);
  }

  return [response, deleteGameKey, error] as const;
};

export const useDeleteMultipleGameKeys = () => {
  const { response, error, issueRequest } = useAxios<Record<string, never>>();
  
  const deleteMultipleGameKeys = useCallback((ids: string[]) => {
    return issueRequest({ 
      url: `/admin/games/keys/bulk-delete`, 
      method: 'post',
      body: { ids }
    });
  }, [issueRequest]);

  // Логируем ошибки для отладки
  if (error) {
    console.log('useDeleteMultipleGameKeys error:', error);
  }

  return [response, deleteMultipleGameKeys, error] as const;
};

export const useUpdateGameKeyField = () => {
  const { response, error, issueRequest } = useAxios<Record<string, never>>();

  const updateGameKey = useCallback(
    (id: string, body: Partial<CreateKeyFormInputs>) => {
      return issueRequest({
        url: `/admin/games/keys/${id}`,
        method: 'put',
        body,
      });
    },
    [issueRequest]
  );

  return [response, updateGameKey] as const;
};

export const useExportGameKeys = () => {
  const { response, error, issueRequest } = useAxios();

  const exportGameKeys = useCallback((limit: string) => {
    return issueRequest({
      url: `/admin/games/keys/export?limit=${limit}`,
      method: 'get',
      responseType: 'blob',
    });
  }, [issueRequest]);

  return [response, exportGameKeys] as const;
};
